import React from 'react'
import { PlayButton } from './assets/PlayButton'
import { SevenPlusLogo } from './assets/SevenPlusLogo'
import { StyledButton } from './ScoreBoard.styled'

interface ScoreBoardMoreButtonProps {
    type: 'cricket' | 'afl' | 'fifa-wwc'
    gameId?: string
}

export const ScoreBoardMoreButton = ({
    type,
    gameId,
}: ScoreBoardMoreButtonProps) => {
    const fifaWWWCWatchLiveButtonLink =
        'https://7plus.com.au/fifa-womens-world-cup-2023?utm_source=7NEWS&utm_medium=match-centre&utm_campaign=fifa-wwc-2023'
    const fifaWWWCMoreSportButtonLink =
        'https://7plus.com.au/fifa-womens-world-cup-2023?utm_source=7NEWS&utm_medium=match-centre&utm_campaign=fifa-wwc-2023'

    switch (type) {
        case 'cricket':
            return (
                <StyledButton to="https://7plus.com.au/7-cricket?utm_source=7NEWS&utm_medium=match-centre&utm_campaign=cricket">
                    <PlayButton />
                    {gameId === '57006' ? 'Watch Live on ' : 'More Cricket on '}
                    <SevenPlusLogo />
                </StyledButton>
            )
        case 'afl':
            return (
                <StyledButton to="https://7plus.com.au/afl?utm_source=7NEWS&utm_medium=afl-match-centre-button&utm_campaign=afl">
                    <PlayButton /> More AFL on <SevenPlusLogo />
                </StyledButton>
            )
        case 'fifa-wwc':
            return (
                <StyledButton
                    to={
                        gameId && liveGamesId.includes(gameId)
                            ? fifaWWWCWatchLiveButtonLink
                            : fifaWWWCMoreSportButtonLink
                    }
                >
                    <PlayButton />
                    {gameId && liveGamesId.includes(gameId)
                        ? 'Watch Live on'
                        : 'More Sport on'}{' '}
                    <SevenPlusLogo />
                </StyledButton>
            )
        default:
            return null
    }
}

//list of games available on 7plus, need to add game id to array when round of 16 and quarter finnals be confirmed
const liveGamesId = [
    '2260571',
    '2260577',
    '2260579',
    '2260580',
    '2260581',
    '2260593',
    '2260631',
    '2260632',
    '2260634',
    '2260620',
    '2260623',
    '2260625',
    '2260622',
]
